import { ActionCreatorWithPayload } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "../reducers";

export const usePropertyUpdate = <T>(
    setAction: ActionCreatorWithPayload<T, string>,
    propertySelector: (state: RootState) => T
) => {
    const dispatch = useDispatch();
    const propertyValue = useSelector(propertySelector);

    const updateStoreProp = (newValue: T) => {
        dispatch(setAction(newValue));
    }

    return {
        propertyValue,
        updateStoreProp
    }
}